import { CommonContexts, IModal, UuiContexts } from '@epam/uui-core'
import {
  BasicModalWindow,
  IBasicModalWindowModalProps,
} from './BasicModalWindow'
import { ReactNode } from 'react'
import { Button } from '@epam/loveship'

const defaultButtons = [
  (
    modalProps: IModal<string> & IBasicModalWindowModalProps,
    key: number | string
  ): ReactNode => (
    <Button
      color="sky"
      fill="white"
      caption="Cancel"
      onClick={() => modalProps && modalProps.abort()}
      key={key}
    />
  ),
  (
    modalProps: IModal<string> & IBasicModalWindowModalProps,
    key: number | string
  ): ReactNode => (
    <Button
      color="sky"
      caption={modalProps.messages.action}
      onClick={() =>
        modalProps &&
        modalProps.success(modalProps.messages.successNotification)
      }
      key={key}
    />
  ),
]

export const showModalWindow = (
  svc: CommonContexts<UuiContexts, any>,
  messages: Record<string, string>,
  successActionCallback?: () => Promise<void>,
  buttons: ((
    modalProps: IModal<string> & IBasicModalWindowModalProps,
    key: number | string
  ) => ReactNode)[] = defaultButtons
) => {
  return svc.uuiModals.show<string>((modalProps) => {
    return (
      <BasicModalWindow
        {...modalProps}
        success={(message: string) => {
          ;(successActionCallback &&
            successActionCallback().then(() => modalProps.success(message))) ||
            modalProps.success(message)
        }}
        buttons={buttons}
        messages={messages}
      />
    )
  })
}
